import { Dispatch } from 'react'
import { Modal } from 'antd';
import { ApiCallsFactory } from "@factories/index"
import { getSession } from '@helpers/users/index'

const getUsers = async (pageNumber = 1, pageSize = 10) => {
  const currentSession = await getSession()
  const getService = new ApiCallsFactory(`/user?pageNumber=${pageNumber}&&pageSize=${pageSize}`,currentSession.token)
  const response = await getService.getData()
  return response
}

const getChains = async () => {
  const currentSession = await getSession()
  const getService = new ApiCallsFactory(`/property/chain`,currentSession.token)
  const response = await getService.getData()
  return response
}

const getUserChains = async ({ id } : { id: number }) => {
  const currentSession = await getSession() 
  const getService = new ApiCallsFactory(`/user/${id}`,currentSession.token)
  const response = await getService.getData()
  return response 
}


const getChainsForUser = async ({ id } : { id: number }) => {
  const currentSession = await getSession() 
  const getService = new ApiCallsFactory(`/user/getChains/${id}`, currentSession.token)
  const response = await getService.getData()
  return response 
}
const updateUserChains = async ({ id, body } : { id: number, body: {} }) => {
  const currentSession = await getSession()
  const service = new ApiCallsFactory(`/user/${id}`,currentSession.token, body)
  const response = await service.putData()
  return response 
}

const userActivation = async (
  { status, userId, setUsersData } : 
  { status: string, userId: string, setUsersData: Dispatch<any> }
) => {
  try {
    const currentSession = await getSession()
    const getService = new ApiCallsFactory(`/user/${userId}?status=${status === 'Inactive' ? 'active': 'inactive'}`,currentSession.token)
    await getService.putData()
    const response: { users: {}[] } | any = await getUsers()
    setUsersData(response?.users)
  } catch (error: any) {
    throw error
  }
}

const ModalHead = () => {
  return (
      <div className='modalHead'>Confirm</div>
  )
}

const EditUser = (e:React.MouseEvent, setIsOnEdit: (status: boolean) => void) =>{
  e.stopPropagation();
  /* Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to edit ?`,
      cancelText: 'Cancel',
      okText: 'Edit',
      onOk: () => setIsOnEdit(true) 
  }); */
  return setIsOnEdit(true) 
}

const userActions = (
  e: React.MouseEvent, 
  status: string, 
  record: { id: string },
  setUsersData: Dispatch<any>
  )=>{
  e.stopPropagation();
  Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to ${status === 'Inactive' ? 'activate' : 'deactivate'} ?`,
      cancelText: 'Cancel',
      okText: `${status === 'Inactive' ? 'Activate' : 'Deactivate'}`,
      onOk: () => userActivation({ status, userId: record?.id, setUsersData })
  });
}

const DeleteUser = (e:React.MouseEvent) => {
  e.stopPropagation();
  Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
  });
}

export {
  getUsers,
  userActivation,
  EditUser,
  userActions,
  DeleteUser,
  getChains,
  getUserChains,
  updateUserChains,
  getChainsForUser
}
